var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2715 7.92343L11.9166 17.154M7.00599 17.154L6.65113 7.92343M16.8745 4.63121C17.2252 4.68454 17.5739 4.74095 17.9226 4.80146M16.8745 4.63121L15.7791 18.8698C15.7344 19.4495 15.4725 19.991 15.0458 20.3859C14.6191 20.7809 14.059 21.0002 13.4776 21H5.44501C4.86359 21.0002 4.30353 20.7809 3.87683 20.3859C3.45013 19.991 3.18824 19.4495 3.14353 18.8698L2.04818 4.63121M16.8745 4.63121C15.6908 4.45225 14.5009 4.31644 13.3074 4.22404M2.04818 4.63121C1.69742 4.68351 1.34871 4.73992 1 4.80043M2.04818 4.63121C3.23187 4.45226 4.42169 4.31644 5.61526 4.22404M13.3074 4.22404V3.28458C13.3074 2.07435 12.3741 1.06515 11.1638 1.0272C10.0291 0.990933 8.89352 0.990933 7.75879 1.0272C6.54857 1.06515 5.61526 2.07538 5.61526 3.28458V4.22404M13.3074 4.22404C10.7471 4.02617 8.17548 4.02617 5.61526 4.22404",
    stroke: "#26AB6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/delete-file.dc83870cc1befab34abfd1f9cb46c0e7.svg";
export { ForwardRef as ReactComponent };